/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const data = {
    img: "https://i.ibb.co/zbvNJ3h/slingtv-created-asset-description-750-700.png",
    title: "Created Assets",
    description:
      "In this section you can view all the assets that you / your organisation has created in Sling Mintpad.",
    meta: [
      {
        key: "",
        value: "From this section, you can,",
      },
      {
        key: "",
        value: "- Edit your Asset details",
      },
      {
        key: "",
        value: "- List the Asset in any Sling Supported Marketplace for Selling in Crypto",
      },
      {
        key:
          "",
        value: "• List the Asset in any Sling Supported Marketplace for Selling in USD",
      },
      {
        key:
          "",
        value: "• Showcase the asset in any Sling Supported Marketplace for Others to view.",
      },

      {
        key:"",
        value:"Note: \n Sling runs its verification algorithms before allowing you to list them. Based on these, assets can be in below states before you can list them."
      },
      {
        key:"",
        value:"- Verification Pending : Sling algorithms are still running. No action is required from your side."
      },
      {
        key:"",
        value:"- Action Required : Your asset didn’t meet the guidelines. Please verify the requirements & update your asset."
      },
      {
        key: "",
        value: "- Read More",
      },
      {
        key: "",
        value: "• Created Assets",
        path: "/assets-list",
      },
      {
        key: "",
        value: "• Created Assets Table",
        path: "/table-view",
      },
    ],
    // buttons: [
    //   {
    //     key: "edit",
    //     title: "Edit",
    //   },
    // ],
  };